import { types, applySnapshot } from 'mobx-state-tree';
import Match from './../matchesStore/Match';

const Season = types
    .model('Season', {
        id: types.identifierNumber,
        title: types.optional(types.string, ''),
        current: types.optional(types.boolean, false),
        games: types.optional(types.array(Match), []),
    })
    .actions((self) => ({
        editSeason(edited) {
            applySnapshot(self, { ...self, ...edited });
        },
    }));

export default Season;
